<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolAttendanceManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/attendance-management/student-attendance",
                title: "Student Attendance",
                description: "Record and review student attendance by class and date.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/attendance-management/student-sign-in-sign-out",
                title: "Student Sign In/Sign Out Attendance",
                description: "Track student arrival and departure times.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Teacher Attendance",
                description: "Record and review staff attendance at school.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
